// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";
import { isMobile } from "./isMobile";

// import the latest version
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
  EffectFade,
  Scrollbar,
} from "swiper";

import AOS from "aos";

// configure Swiper to use modules
Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
  EffectFade,
  Scrollbar,
]);

/*
 *
 * ----------------------------------------------- */
var swiperFv = document.querySelector(".swiper-fv");

if (swiperFv) {
  setTimeout(function () {
    new Swiper(swiperFv, {
      effect: "fade",
      fadeEffect: {
        crossFade: false,
      },
      speed: 2000,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    AOS.refresh();
  }, 4500);
}

jQuery(".swiper-pagination-bullet").each(function (index, value) {
  jQuery(this).append(
    '<svg height="26" width="26">\n' +
      '  <circle class="circle" cx="13" cy="13" r="12" stroke="#ffffff" stroke-width="2" fill-opacity="0" />\n' +
      "  </svg>"
  );
});

jQuery(".swiper-pagination-bullet svg").each(function (index, value) {
  jQuery(this).hide();
});

/*
 *
 * ----------------------------------------------- */
var swiperEvent = document.querySelector(".swiper-event");

if (swiperEvent) {
  new Swiper(swiperEvent, {
    slidesPerView: "auto",
    spaceBetween: 32,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    // },
    scrollbar: {
      el: ".swiper-scrollbar",
      dragSize: 100,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      1400: {
        slidesPerView: 4,
      },

      992: {
        slidesPerView: 3,
        spaceBetween: 44,
        scrollbar: {
          dragSize: 306,
        },
      },
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperSightseeing = document.querySelector(".swiper-sightseeing");

if (swiperSightseeing && isMobile()) {
  new Swiper(swiperSightseeing, {
    slidesPerView: "auto",
    spaceBetween: 25,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    // },
    scrollbar: {
      el: ".swiper-scrollbar",
      dragSize: 100,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      992: {
        slidesPerView: 6,
        spaceBetween: 0,
      },
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperCandleLightDinner = document.querySelector(
  ".swiper-candle-light-dinner"
);
if (swiperCandleLightDinner) {
  new Swiper(swiperCandleLightDinner, {
    slidesPerView: 1.3,
    spaceBetween: 18,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.4,
        spaceBetween: 30,
      },
    },
  });
}
